<template>
  <div>
    <div class="post" v-for="article in filteredPosts">
      <div v-on:click="showPost(article.id)" style="cursor: pointer;">
        <span class="rightPanel">
          <DateBadge :date="article.date"/>
        </span>
        <span class="leftPanel" v-on:click="showPost(article.id)">
          <h3>
            {{article.title}}
          </h3>
          <span class="tags">
            <span v-for="tag in article.tags" class="post-tag">
              {{tag}}
            </span>
          </span>
        </span>
        <p class="contentShort">
          {{article.contentShort}}
        </p>
        <div style="clear: both"></div>
        <div v-if='filteredPosts.length'><span id="contentLoaded"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import Router from 'vue-router';

import DateBadge from '@/components/DateBadge';
import VueMarkdown from 'vue-markdown';

import store from '@/store';

export default {
  name: 'BlogFeed',
  data() {
    return {
    };
  },

  computed: {
    filteredPosts() {
      setTimeout(function () {
        document.dispatchEvent(new Event('vue-content-render'));
      }, 1);
      return store.getters.getFilteredPosts;
    }
  },

  methods: {
    showPost(id) {
      this.$router.push('/article/' + id);
    },
  },

  components: {
    DateBadge,
    VueMarkdown,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BlogFeed.vue